/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiDefSupportReport } from '../../models/api-def-support-report';

export interface OrganizationsGetSupportReportById$Params {
  organizationId: string;
  reportId: string;
}

export function organizationsGetSupportReportById(http: HttpClient, rootUrl: string, params: OrganizationsGetSupportReportById$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiDefSupportReport>> {
  const rb = new RequestBuilder(rootUrl, organizationsGetSupportReportById.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('reportId', params.reportId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiDefSupportReport>;
    })
  );
}

organizationsGetSupportReportById.PATH = '/organizations/{organizationId}/support/{reportId}';
